export enum ContentWizardStep {
    selectContentType,
    chooseMedia,
    enterSubject,
    applyFilters,
    contentResult,
    generateSimilar
}